var map = {
	"./cargo.svg": 9563,
	"./fishing-vessel.svg": 3306,
	"./high-speed-craft.svg": 8576,
	"./passenger-ship.svg": 961,
	"./tanker.svg": 1124,
	"./tug.svg": 6970,
	"./unknown-vessel.svg": 4315,
	"./yacht.svg": 2945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4499;